import React, { useRef } from "react"
import { VaccinationRecipiencyProps } from "../types";

export const VaccinationRecipiency: React.VFC<VaccinationRecipiencyProps> = ({ recipiency, showDistanceSort, selectedDateTimeInterval, visuellIdentitet, svgArrow }) => {
    const description = useRef<HTMLDivElement>();

    let ariaText = recipiency.municipalityCode !== null && recipiency.municipalityCode !== undefined && recipiency.municipalityName + " kommun";
    ariaText += recipiency.municipalityCode !== null && recipiency.municipalityCode !== undefined && recipiency.district !== null && recipiency.district !== undefined && " " + recipiency.district;
    ariaText += recipiency.distance && showDistanceSort && " " + Math.round(recipiency.distance * 10) / 10 + " km från dig";

    let recipiencyId = `mottagning-${recipiency.hsaid}`;

    const mainClassName = visuellIdentitet ? "vaccinationpage" : "vgr-listitem";

    return (
        <>
            <article className="vgr-searchservice-item">
                <header className="vgr-searchservice-item__header">
                    <div>
                        <a className={`${mainClassName}__header-link`} href={recipiency.websiteUrl} aria-describedby={recipiencyId}>
                            <h3 className={`${mainClassName}__heading`}>{recipiency.title}</h3>
                        </a>
                        <h4 className="vgr-searchservice-item__sub-heading" aria-label={ariaText}>
                            {recipiency.municipalityCode !== null &&
                                recipiency.municipalityCode !== undefined &&
                                <>{recipiency.municipalityName + " kommun"}</>
                            }
                            {recipiency.municipalityCode !== null &&
                                recipiency.municipalityCode !== undefined &&
                                recipiency.district !== null &&
                                recipiency.district !== undefined &&
                                <> • {recipiency.district}</>
                            }
                            {recipiency.distance ? showDistanceSort &&
                                <> • {Math.round(recipiency.distance * 10) / 10} km från dig</> :
                                recipiency.latitude == null && recipiency.longitude == null && showDistanceSort && <> • Uppgifter om avstånd saknas</>
                            }
                        </h4>
                    </div>
                    <div id={recipiencyId} className='vgr-searchservice-item__badgewrapper'>
                        {(recipiency.timeslots !== null && recipiency.timeslots !== 0 && recipiency.timeslots !== 1 && recipiency.timeslots < 100) && (selectedDateTimeInterval === "alla-kommande-tider" || selectedDateTimeInterval == undefined) &&
                            <div className="vgr-badge vgr-badge--success">{recipiency.timeslots + " bokningsbara tider"}</div>
                        }
                        {(recipiency.timeslots !== null && recipiency.timeslots !== 0 && recipiency.timeslots !== 1 && recipiency.timeslots > 100) && (selectedDateTimeInterval === "alla-kommande-tider" || selectedDateTimeInterval == undefined) &&
                            <div className="vgr-badge vgr-badge--success">Fler än 100 bokningsbara tider</div>
                        }
                        {(recipiency.timeslots !== null && recipiency.timeslots !== 0 && recipiency.timeslots == 1) && (selectedDateTimeInterval === "alla-kommande-tider" || selectedDateTimeInterval == undefined) &&
                            <div className="vgr-badge vgr-badge--success">{recipiency.timeslots + " bokningsbar tid"}</div>
                        }
                        {(recipiency.timeslots !== null && recipiency.timeslots !== 0 && recipiency.timeslots !== 1 && recipiency.timeslots < 100) && selectedDateTimeInterval !== undefined && selectedDateTimeInterval !== "alla-kommande-tider" &&
                            <div className="vgr-badge vgr-badge--success">{recipiency.timeslots + " bokningsbara tider inom " + selectedDateTimeInterval}</div>
                        }
                        {(recipiency.timeslots !== null && recipiency.timeslots !== 0 && recipiency.timeslots !== 1 && recipiency.timeslots > 100) && selectedDateTimeInterval !== undefined && selectedDateTimeInterval !== "alla-kommande-tider" &&
                            <div className="vgr-badge vgr-badge--success">{"Fler än 100 bokningsbara tider inom " + selectedDateTimeInterval}</div>
                        }
                        {(recipiency.timeslots !== null && recipiency.timeslots !== 0 && recipiency.timeslots == 1) && selectedDateTimeInterval !== undefined && selectedDateTimeInterval !== "alla-kommande-tider" &&
                            <div className="vgr-badge vgr-badge--success">{recipiency.timeslots + " bokningsbar tid inom " + selectedDateTimeInterval}</div>
                        }
                        {(recipiency.timeslots == null || recipiency.timeslots == 0) && (selectedDateTimeInterval === "alla-kommande-tider" || selectedDateTimeInterval == undefined) &&
                            <div className="vgr-badge vgr-badge--warning">Inga bokningsbara tider just nu</div>
                        }
                        {(recipiency.timeslots == null || recipiency.timeslots == 0) && selectedDateTimeInterval !== undefined && selectedDateTimeInterval !== "alla-kommande-tider" &&
                            <div className="vgr-badge vgr-badge--warning">{"Inga bokningsbara tider inom " + selectedDateTimeInterval}</div>
                        }
                        {recipiency.dropin &&
                            <div className="vgr-badge vgr-badge--info">Drop-in erbjuds vissa tider</div>
                        }
                    </div>
                </header>
                {(recipiency.provisionText || recipiency.dropinText || recipiency.address) &&
                    <div className={`${mainClassName}__expandable-body`}>
                        {(recipiency.dropinText !== null && recipiency.dropinText !== undefined && recipiency.dropin && recipiency.address) ||
                            (recipiency.phoneNumber !== null && recipiency.phoneNumber !== undefined) ||
                            (recipiency.provisionText !== null && recipiency.provisionText !== undefined) ? (
                            <details>
                                <summary>
                                    <span>
                                        <span className="title-show">Visa</span>
                                        <span className="title-hide">Dölj</span> mer uppgifter
                                        <span className='sr-only'>&nbsp;om {recipiency.title}</span>
                                    </span>{' '}<svg width='16px' height='16px'>
                                        <use href={svgArrow} width='16px' height='16px' />
                                    </svg>
                                </summary>
                                {recipiency.dropinText !== null &&
                                    recipiency.dropinText !== undefined &&
                                    recipiency.dropin &&
                                    recipiency.address &&
                                    <div className={`${mainClassName}__expandable__nested-details-body`}>
                                        <strong>Adress</strong>
                                        <br />
                                        {recipiency.address.streetAdress}, {recipiency.address.zipCode}, {recipiency.address.city}
                                    </div>
                                }
                                {recipiency.phoneNumber !== null &&
                                    recipiency.phoneNumber !== undefined &&
                                    <div className={`${mainClassName}__expandable__nested-details-body`}>
                                        <strong>Telefonnummer</strong>
                                        <br />
                                        {recipiency.phoneNumber}
                                    </div>
                                }
                                {recipiency.provisionText !== null &&
                                    recipiency.provisionText !== undefined &&
                                    <div className={`${mainClassName}__expandable__nested-details-body`}>
                                        <strong>Kompletterande information</strong>
                                        <br />
                                        <div dangerouslySetInnerHTML={{ __html: recipiency.provisionText }}></div>
                                    </div>
                                }
                            </details>
                        ) : null
                        }
                        {(recipiency.dropinText || recipiency.address !== null) &&
                            <div ref={description} className={`${mainClassName}__description`}>
                                {recipiency.dropinText !== null &&
                                    recipiency.dropinText !== undefined &&
                                    recipiency.dropin ?
                                    <>
                                        <strong>Information om drop-in</strong>
                                        <br />
                                        <div dangerouslySetInnerHTML={{ __html: recipiency.dropinText }}></div>
                                    </> :
                                    <>
                                        <div>
                                            <strong>Adress</strong>
                                            <br />
                                            {recipiency.address.streetAdress}, {recipiency.address.zipCode}, {recipiency.address.city}
                                        </div>
                                    </>
                                }
                            </div>
                        }
                    </div>
                }
                {(recipiency.urlBooking != null && recipiency.urlBooking != "" && !(recipiency.timeslots == null || recipiency.timeslots == 0)) ? (
                    <>
                        <div className={`${mainClassName}__divider2`} />
                        <footer>
                            <ul>
                                <li>
                                    <a href={recipiency.urlBooking}>Boka tid via webben hos {recipiency.title}</a>
                                </li>
                            </ul>
                        </footer>
                    </>
                ) : null
                }
            </article>
        </>
    );
}